import { Circle } from '@mui/icons-material';
import { Button, Stack, Typography } from '@mui/material';
import Link from 'next/link';
import { FormattedDate, FormattedMessage } from 'react-intl';
import type { EventDto } from 'api/generated';
import { GetColorByAvailability } from 'lib/helpers/availability-color';
interface CalendarEventButtonProps {
  event: EventDto;
  onClick?: () => void;
  href?: string;
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}
export function CalendarEventButton({
  event,
  onClick,
  href,
  size,
  fullWidth
}: CalendarEventButtonProps) {
  const eventDisabled = event.saleStatus === 'Cancelled' || event.saleStatus === 'SoldOut';
  return <Button {...href ? {
    component: Link,
    href
  } : {}} fullWidth={fullWidth} variant={eventDisabled ? 'contained' : 'outlined'} color="monochrome" sx={{
    paddingLeft: 2,
    textDecoration: 'none',
    '> span': {
      position: 'absolute',
      left: 8,
      margin: 0,
      padding: 0
    }
  }} size={size ?? 'small'} startIcon={<Circle sx={{
    height: '10px',
    color: GetColorByAvailability(event)
  }} />} disabled={eventDisabled} onClick={onClick}>
      <FormattedDate value={event.startDate} hour="2-digit" minute="2-digit" />
    </Button>;
}
export const CalendarEventButtonStatusLabel = () => {
  return <Stack direction={'row'} sx={{
    gap: 2,
    alignItems: 'center'
  }}>
      <Stack direction={'row'} sx={{
      gap: 1,
      alignItems: 'center'
    }}>
        <Circle sx={{
        color: 'success.main',
        height: '5px',
        width: '5px'
      }} />
        <Typography variant="body3" sx={{
        color: 'text.secondary'
      }}>
          <FormattedMessage id="common.available" defaultMessage={[{
          "type": 0,
          "value": "Available"
        }]} />
        </Typography>
      </Stack>
      <Stack direction={'row'} sx={{
      gap: 1,
      alignItems: 'center'
    }}>
        <Circle sx={{
        color: 'warning.main',
        height: '5px',
        width: '5px'
      }} />
        <Typography variant="body3" sx={{
        color: 'text.secondary'
      }}>
          <FormattedMessage id="common.fewLeft" defaultMessage={[{
          "type": 0,
          "value": "Few left"
        }]} />
        </Typography>
      </Stack>
      <Stack direction={'row'} sx={{
      gap: 1,
      alignItems: 'center'
    }}>
        <Circle sx={{
        color: 'error.main',
        height: '5px',
        width: '5px'
      }} />
        <Typography variant="body3" sx={{
        color: 'text.secondary'
      }}>
          <FormattedMessage id="common.soldOut" defaultMessage={[{
          "type": 0,
          "value": "Sold out"
        }]} />
        </Typography>
      </Stack>
      <Stack direction={'row'} sx={{
      gap: 1,
      alignItems: 'center'
    }}>
        <Circle sx={{
        color: 'text.disabled',
        height: '5px',
        width: '5px'
      }} />
        <Typography variant="body3" sx={{
        color: 'text.secondary'
      }}>
          <FormattedMessage id="common.unavailable" defaultMessage={[{
          "type": 0,
          "value": "Unavailable"
        }]} />
        </Typography>
      </Stack>
    </Stack>;
};